/*
 Created by qing 2019/12/21 7:37 下午
 */

import BaseItem from "../BaseItem"
import {DATA_TYPE__STRING, DEFAULT_VALUE__CUSTOM, FORM_ITEM__PHONE, FORM_ITEM__TABLE, FORM_STATUS__FILL} from "../types"

class Phone extends BaseItem {
  constructor() {
    super()

    // 填写内容
    this.value = ''

    this.whiteSwitch = 0 // 白名单开关 0 关 1 开
    this.whiteList = [] // 白名单列表
    this.blackSwitch = 0  // 黑名单开关 0 关 1 开
    this.blackList = []  // 黑名单列表
    this.codeCheck = 1 // 短信验证 0 关 1 开 默认开

    this.authCode = '' // 用户填写的验证码
    this.codeThroughCheck = false // 验证码是否通过校验

    this.defaultValue = {
      defaultType: ''
    }
  }

  get title() {
    return this.fieldTitle || Phone._title
  }

  set title(val) {
    this.fieldTitle = val
    this.temTitle = val
  }
}

Phone._title = '手机'
Phone.type = FORM_ITEM__PHONE
Phone.use = true
Phone.icon = 'iconfont icon-shoujihao'

// 组件类型
Phone.prototype.type = Phone.type
// 数据类型
Phone.prototype.dataType = DATA_TYPE__STRING

Phone.prototype.getValue = function () {
  return this.value
}
Phone.prototype.setValue = function (val) {
  if (this.parent && this.parent.type === FORM_ITEM__TABLE) {
    return
  }
  this.value = val || ''
}
Phone.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    defaultValue: this.defaultValue,
    codeCheck: this.codeCheck,
    whiteSwitch: this.whiteSwitch,
    whiteList: this.whiteList,
    blackSwitch: this.blackSwitch,
    blackList: this.blackList
  }
}
Phone.prototype.setConf = function (opts) {
  this.setBase(opts)
  this.codeCheck = opts.codeCheck === 0 ? 0 : 1
  this.whiteSwitch = opts.whiteSwitch || 0
  this.blackSwitch = opts.blackSwitch || 0
  if (opts.whiteList) this.whiteList = opts.whiteList
  if (opts.blackList) this.blackList = opts.blackList
  // 如果没有打开短信验证，默认就是通过验证
  if (this.codeCheck) {
    this.codeThroughCheck = false
  } else {
    this.codeThroughCheck = true
  }
  if (opts.defaultValue) {
    this.defaultValue = opts.defaultValue
    if (opts.defaultValue.defaultType === DEFAULT_VALUE__CUSTOM) {
      this.value = this.defaultValue.customValue
    }
  }
}
Phone.prototype.valueToString = function (value) {
  value = value || this.value
  return value
}

// 检查数据合法性 true合法 false不合法
Phone.prototype.checkData = function () {
  // 判断必填
  // if (!this.checkWriteValue()) {
  //   console.log('checkWriteValue', this.checkWriteValue())
  //   return false
  // }
  // 判断白名单 黑名单
  if (!this.checkList()) {
    return false
  }
  // 校验短信验证码
  if (this.codeCheck && !this.root.stepId) {
    if (this.value.length) {
      return this.codeThroughCheck
    } else {
      return true
    }
  } else {
    return true
  }
}

// 判断必填项
Phone.prototype.checkWriteValue = function () {
  if (this.root.status === FORM_STATUS__FILL && this.required && !this.value.length) {
    return false
  } else {
    return true
  }
}

Phone.prototype.checkList = function() {
  if (this.whiteSwitch === 1) {
    // 白名单通过就不需要过黑名单了
    if (this.whiteList.includes(this.value)) {
      return true
    } else {
      return false
    }
  } else {
    return this.checkBlackList()
  }
}

// 判断黑名单
Phone.prototype.checkBlackList = function () {
  if (this.blackSwitch === 1) {
    if (this.blackList.includes(this.value)) {
      return false
    } else {
      return true
    }
  } else {
    return true
  }
}

// 判断是否展示错误codeUI
Phone.prototype.isShowCodeError = function() {
  if (!this.root.stepId && this.value.length) {
    return !this.codeThroughCheck
  } else {
    return false
  }
}

export default Phone
